<ng-container *ngIf="maintenance$ | async as maintenance; else noMaintenance">
  <main style="text-align: center; font-size: 16px; padding-top: 2em">
    <p><i class="fas fa-tools" style="font-size: 48px" aria-hidden="true"></i></p>
    <h1 style="font-size: 1.5em">{{ 'maintenance.title' | translate }}</h1>
    <p *ngIf="maintenance.reason">{{ maintenance.reason }}</p>
    <p *ngIf="maintenance.endDate">
      {{ 'maintenance.plannedEnd' | translate }}: {{ formatDate(maintenance.endDate) }}
      {{ 'components.maintenance.uhr' | translate }}
    </p>
    <button (click)="signOut()" class="sign-out" id="btn_sign-out">
      <i class="fas fa-sign-out-alt" aria-hidden="true"> </i> {{ 'action.signout' | translate }}
    </button>
  </main>
</ng-container>
<ng-template #noMaintenance>
  <ng-container *ngIf="Initialized">
    <div class="main-layout">
      <app-navbar *ngIf="(maintenance$ | async) === null"></app-navbar>
      <main style="position: relative">
        <router-outlet></router-outlet>
      </main>
      <div kendoDialogContainer></div>
      <div kendoWindowContainer></div>
    </div>
  </ng-container>

  <main *ngIf="router.url === '/login'">
    <router-outlet></router-outlet>
  </main>
</ng-template>
